/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface ValidationTestDTO
 */
export interface ValidationTestDTOOptional {
  /**
   *
   * @type {string}
   * @memberof ValidationTestDTO
   */
  testA?: string;
  /**
   *
   * @type {number}
   * @memberof ValidationTestDTO
   */
  testB?: number;
  /**
   *
   * @type {string}
   * @memberof ValidationTestDTO
   */
  testC?: string;
}

export interface ValidationTestDTO extends ValidationTestDTOOptional {
  /**
   *
   * @type {string}
   * @memberof ValidationTestDTO
   */
  testA?: string;
  /**
   *
   * @type {number}
   * @memberof ValidationTestDTO
   */
  testB?: number;
  /**
   *
   * @type {string}
   * @memberof ValidationTestDTO
   */
  testC?: string;
}

export interface ValidationTestDTOTrackedI {
  /**
   *
   * @type {string}
   * @memberof ValidationTestDTO
   */
  testA?: string;
  testAIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ValidationTestDTO
   */
  testB?: number;
  testBIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ValidationTestDTO
   */
  testC?: string;
  testCIsSet: boolean;
}

transformDatesMap.set(
  "ValidationTestDTO",
  function (model: ValidationTestDTO) {},
);

export type ValidationTestDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  testA: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  testB: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  testC: PropertyMeta<MetaTypeBase<string>>;
}>;

export var ValidationTestDTOMeta: ValidationTestDTOMetaI =
  {} as ValidationTestDTOMetaI;
ValidationTestDTOMeta = typeMeta("ValidationTestDTO", {
  testA: propertyMeta("testA", false, false, false, MetaTypesBase.string),
  testB: propertyMeta("testB", false, false, false, MetaTypesBase.number),
  testC: propertyMeta("testC", false, false, false, MetaTypesBase.string),
});

const metaI = ValidationTestDTOMeta;

registerMeta(() => {});

export class ValidationTestDTOTracked implements ValidationTestDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  testA__I?: string = undefined;
  testAIsSet: boolean = false;
  set testA(v: undefined | string) {
    if (v !== undefined) {
      this.testA__I = v;
      this.testAIsSet = true;
    } else {
      this.testA__I = v || undefined;
      this.testAIsSet = false;
    }
    this.changeTracker = true;
  }
  get testA() {
    return this.testA__I;
  }
  testB__I?: number = undefined;
  testBIsSet: boolean = false;
  set testB(v: undefined | number) {
    if (v !== undefined) {
      this.testB__I = v;
      this.testBIsSet = true;
    } else {
      this.testB__I = v || undefined;
      this.testBIsSet = false;
    }
    this.changeTracker = true;
  }
  get testB() {
    return this.testB__I;
  }
  testC__I?: string = undefined;
  testCIsSet: boolean = false;
  set testC(v: undefined | string) {
    if (v !== undefined) {
      this.testC__I = v;
      this.testCIsSet = true;
    } else {
      this.testC__I = v || undefined;
      this.testCIsSet = false;
    }
    this.changeTracker = true;
  }
  get testC() {
    return this.testC__I;
  }
  constructor(config?: ValidationTestDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: ValidationTestDTOOptional,
    options?: AssignOptions,
  ): ValidationTestDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.testA && this.testAApplyFilter(optionsRequired.filter)) {
      this.testA = config.testA;
      if (optionsRequired.unassign) this.testAIsSet = false;
      else this.testAIsSet = true;
    }
    if (config.testB && this.testBApplyFilter(optionsRequired.filter)) {
      this.testB = config.testB;
      if (optionsRequired.unassign) this.testBIsSet = false;
      else this.testBIsSet = true;
    }
    if (config.testC && this.testCApplyFilter(optionsRequired.filter)) {
      this.testC = config.testC;
      if (optionsRequired.unassign) this.testCIsSet = false;
      else this.testCIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ValidationTestDTOTrackedI {
    const cloned = {} as ValidationTestDTOTrackedI;
    if (
      this.testAIsSetDeep() &&
      this.testAApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.testAIsSet = true;
      cloned.testA = this.testA;
    } else {
      //cloned.testAIsSet = false
    }
    if (
      this.testBIsSetDeep() &&
      this.testBApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.testBIsSet = true;
      cloned.testB = this.testB;
    } else {
      //cloned.testBIsSet = false
    }
    if (
      this.testCIsSetDeep() &&
      this.testCApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.testCIsSet = true;
      cloned.testC = this.testC;
    } else {
      //cloned.testCIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ValidationTestDTOTrackedI {
    if (!this.testAApplyFilter(filter)) this.testAIsSet = false;

    if (!this.testBApplyFilter(filter)) this.testBIsSet = false;

    if (!this.testCApplyFilter(filter)) this.testCIsSet = false;

    return this;
  }
  testAApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ValidationTestDTOMeta.testA,
      ValidationTestDTOMeta,
      this.testA,
      this,
    );
  }
  testAIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.testAIsSet && this.testAApplyFilter(filter)) return true;

    return false;
  }
  testBApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ValidationTestDTOMeta.testB,
      ValidationTestDTOMeta,
      this.testB,
      this,
    );
  }
  testBIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.testBIsSet && this.testBApplyFilter(filter)) return true;

    return false;
  }
  testCApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ValidationTestDTOMeta.testC,
      ValidationTestDTOMeta,
      this.testC,
      this,
    );
  }
  testCIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.testCIsSet && this.testCApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.testAIsSetDeep(filter)) return true;
    if (this.testBIsSetDeep(filter)) return true;
    if (this.testCIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
